var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128,3C59,3,3,59,3,128s56,125,125,125s125-56,125-125S197,3,128,3z M195,92l-85.5,85.5c-3.5,3.5-9.1,3.7-12.9,0.5    l-34.8-30.1c-0.2-0.2-0.4-0.4-0.7-0.6c-3.8-3.6-4-9.6-0.4-13.4s9.6-4,13.4-0.4l28.1,24.3l79.2-79.2c1.7-1.8,4.1-2.8,6.5-2.9v0    c2.6-0.1,5.2,1,7.1,2.8C198.8,82.3,198.7,88.3,195,92z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.441d3efb418702f2d07512e74fc889ed.svg";
export { ForwardRef as ReactComponent };